export const OPEN_MODAL = 'OPEN_MODAL';
export type OPEN_MODAL = typeof OPEN_MODAL;



// WEBPACK FOOTER //
// ./src/actions/modal/open/Types.tsx